
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, PageOptions, Supplier } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class SupplierListProvider implements Resolve<any> {
    supplier: Supplier[];
    supplierEdit: Supplier;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.supplierEdit = this.state?.currentSupplier;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    get(id: number): Observable<Supplier> {
        if (!id) {
            return null;
        }
        return this.gw.get('supplier/:id', { id: id });
    }

    get currentSupplier(): Supplier {
        return this.supplierEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('supplier/').subscribe({
                next: (res: HttpResponse<any>) => {
                    this.supplier = res.body;
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('supplier/search', pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (!CwUtils.compare(this.supplier, res.body.content) && res.body.content.length > 0) {
                        this.supplier = res.body.content;
                        this.onDataChanged.next(this.supplier);
                    }
                    else {
                        this.supplier = res.body.content;
                    };
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getPageTO(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('supplier/search-to', pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

